import { Button, TableItem, TableMessage } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useTranslation } from 'react-i18next';
import { PiPlus, PiTrash } from 'react-icons/pi';
import { useGetLanguages } from 'services/enums';
import { IMusicProductDigitalForm } from 'services/music-product-digital/types/form';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { getLanguageSelectOptions } from 'utils/global/language.utils';

const MusicProductDigitalTitles = () => {
  const {
    values,
    status,
    setFieldValue,
  }: IFormikContextType<IMusicProductDigitalForm> =
    useFormikContext<IMusicProductDigitalForm>();
  const { t } = useTranslation();
  const languages = useGetLanguages();

  return (
    <Table
      id={'MusicProductDigitalTitles'}
      size='default'
      data={{
        nodes: values.otherTitles.map((title, key) => ({ ...title, id: key })),
      }}
      columns={[
        {
          label: t('input.label.title'),
          renderCell: ({ title, id }) => (
            <TableItem>
              {status?.displayMode ? (
                <TableItem.Text text={title} />
              ) : (
                <FormInput.Text
                  name={`otherTitles[${id}].title`}
                  label={t('input.label.title')}
                />
              )}
            </TableItem>
          ),
          resize: true,
        },
        {
          label: t('input.label.language'),
          renderCell: ({ language, id }) => (
            <TableItem className='visible overflow-visible'>
              {status?.displayMode ? (
                <TableItem.Text text={t(`enum.LANGUAGE.${language}`)} />
              ) : (
                <FormInput.Select
                  name={`otherTitles[${id}].language`}
                  label={t('input.label.language')}
                  value={{
                    value: values.otherTitles[id].language,
                    label: t(`enum.LANGUAGE.${language}`),
                  }}
                  options={getLanguageSelectOptions(languages.data, [
                    ...values.otherTitles,
                    values.mainTitle,
                  ])}
                />
              )}
            </TableItem>
          ),
          resize: true,
        },
        {
          label: t('input.label.version'),
          renderCell: ({ version, id }) => (
            <TableItem>
              {status?.displayMode ? (
                <TableItem.Text text={version} />
              ) : (
                <FormInput.Text
                  name={`otherTitles[${id}].version`}
                  label={t('input.label.version')}
                />
              )}
            </TableItem>
          ),
        },
        {
          label: '',
          renderCell: ({ id }) => (
            <TableItem justifyPosition='end'>
              {status?.displayMode ? null : (
                <Button
                  variant={BUTTON_VARIANT.remove}
                  onlyIcon
                  isClear
                  onClick={() =>
                    setFieldValue(
                      'otherTitles',
                      values.otherTitles
                        .filter((_, index) => index !== id)
                        .map((title, index) => ({ ...title, id: index }))
                    )
                  }>
                                    <Button.Description description={t('button.remove')} />

                                    <Button.Icon icon={<PiTrash />} />
                </Button>
              )}
            </TableItem>
          ),
        },
      ]}
      tableOptions={
        status?.displayMode
          ? undefined
          : {
              renderAfterTable: () => (
                <tfoot className='full-width-footer'>
                  <TableMessage
                    className='cursor-pointer'
                    onClick={() =>
                      setFieldValue(
                        `otherTitles[${values.otherTitles.length}]`,
                        {
                          language: -1,
                          isMainTitle: false,
                          title: '',
                          version: '',
                        }
                      )
                    }>
                    <TableItem.Text text={t('button.add')} />
                    <PiPlus />
                  </TableMessage>
                </tfoot>
              ),
            }
      }
    />
  );
};

export default MusicProductDigitalTitles;
